import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import DnrConsentSvc from "@/services/DnrConsent";

@Module({ store, dynamic: true, namespaced: true, name: "dnr-consent" })
class DnrConsentModule extends VuexModule {
  consent: any = null;
  loading = false;

  @Mutation SET_CONSENT(val: any) {
    this.consent = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);

    try {
      const dt = await DnrConsentSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_CONSENT(data);
    } catch {
      this.SET_CONSENT(null);
    }

    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);

    try {
      const dt = await DnrConsentSvc.find(id);
      const { data } = dt.data;
      this.SET_CONSENT(data);
    } catch {
      this.SET_CONSENT(null);
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_CONSENT(null);
  }
}

export const storeDnrConsent = getModule(DnrConsentModule);
